import { YOUTUBE_AUTOMATION_STAGE_STATUSES } from './youtubeAutomationStageStatuses'
import { getToggle } from './youtubeSettingsUtils'
import * as youtubeUrls from './youtubeUrls'
import { YoutubeSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { StageType, YoutubeRecommendationKey } from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

// Settings properties
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value === 'true' ? 'On' : 'Off'))

const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => value === 'true')

const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

const toggleLabels = {
  [YoutubeSettingKey.SUBSCRIPTION_PRIVACY]: 'keep all my subscriptions private',
}

// Stage definitions
enum StageKey {
  GATHER_SETTINGS_SUBSCRIPTION_PRIVACY = 'GATHER_SETTINGS_SUBSCRIPTION_PRIVACY',
  UPDATE_SETTINGS_SUBSCRIPTION_PRIVACY = 'UPDATE_SETTINGS_SUBSCRIPTION_PRIVACY',
  UNDO_SETTINGS_SUBSCRIPTION_PRIVACY = 'UNDO_SETTINGS_SUBSCRIPTION_PRIVACY',
}

const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.GATHER_SETTINGS_SUBSCRIPTION_PRIVACY,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: youtubeUrls.privacyUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      for (const [setting, label] of Object.entries(toggleLabels)) {
        const settingToggle = await getToggle(label)

        await updateStoredInitialValues(
          {
            [setting]: settingToggle.ariaPressed,
          },
          YoutubeRecommendationKey.YOUTUBE_SUBSCRIPTION_PRIVACY,
        )
      }
    },
  },
]

const updateStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.UPDATE_SETTINGS_SUBSCRIPTION_PRIVACY,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: youtubeUrls.privacyUrl,
    action: async (machineContext, userContext) => {
      const { isDry, settingsSelected } = userContext

      for (const [setting, label] of Object.entries(toggleLabels)) {
        if (settingsSelected[setting]) {
          const settingToggle = await getToggle(label)

          if (settingToggle.ariaPressed === 'false' && !isDry) {
            settingToggle.click()
          }
        }
      }
    },
  },
]

const undoStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.UNDO_SETTINGS_SUBSCRIPTION_PRIVACY,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.UNDOING_SETTINGS,
    url: youtubeUrls.privacyUrl,
    action: async (machineContext, userContext) => {
      const { isDry, initialValues, settingsSelected } = userContext

      for (const [setting, label] of Object.entries(toggleLabels)) {
        if (settingsSelected[setting] && initialValues[setting]) {
          const settingToggle = await getToggle(label)

          if (settingToggle.ariaPressed !== initialValues[setting] && !isDry) {
            settingToggle.click()
          }
        }
      }
    },
  },
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
